import { IconProps } from "@/data/types"

export default function BedIcon({ width=32, height=32, color='#000000', className }: IconProps) {
  return (
    <div className={className}>
      <svg viewBox="0 0 24 24" width={width} height={height} fill="none" xmlns="http://www.w3.org/2000/svg">
        <g id="SVGRepo_bgCarrier" strokeWidth="0"></g>
        <g id="SVGRepo_tracerCarrier" strokeLinecap="round" strokeLinejoin="round"></g>
        <g id="SVGRepo_iconCarrier"> 
          <path d="M22 19V16M12 16V8H18C20.2091 8 22 9.79086 22 12V16M12 16H2M12 16H22M2 6V16M2 19V16M9.00001 11C9.00001 12.1046 8.10458 13 7.00001 13C5.89544 13 5.00001 12.1046 5.00001 11C5.00001 9.89543 5.89544 9 7.00001 9C8.10458 9 9.00001 9.89543 9.00001 11Z" stroke={color} strokeWidth="0.72" strokeLinecap="round" strokeLinejoin="round"></path> 
        </g>
      </svg>
    </div>
  )
}